import { Box, keyframes } from "@mui/material";

const dotAnimation = keyframes`
  0%, 20% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const LoadingDots = () => (
  <Box
    component="span"
    sx={{
      display: "inline-block",
      "& span": {
        display: "inline-block",
        animation: `${dotAnimation} 1.4s infinite`,
        fontSize: "inherit",
      },
      "& span:nth-of-type(1)": { animationDelay: "0s" },
      "& span:nth-of-type(2)": { animationDelay: "0.2s" },
      "& span:nth-of-type(3)": { animationDelay: "0.4s" },
    }}
  >
    <span>.</span>
    <span>.</span>
    <span>.</span>
  </Box>
);

export default LoadingDots;
